import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DataLibraryLayout } from '../../components/DataLibrary';
import classes from './DataLibraryPage.module.css';

export function DataLibraryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const cohortParam = searchParams.get('cohort') ?? undefined;
  // MED-1346: a miss tag links to ?tab=one_on_one_history&participant=<user id>.
  // Read once: a cohort click rewrites the URL to ?cohort= only.
  const [initialView] = useState(() => ({
    tab: searchParams.get('tab') ?? undefined,
    participant: searchParams.get('participant') ?? undefined,
  }));

  // A refresh must not apply the link again, so the URL keeps only ?cohort=.
  useEffect(() => {
    if (!initialView.tab && !initialView.participant) return;
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        next.delete('tab');
        next.delete('participant');
        return next;
      },
      { replace: true },
    );
  }, [initialView, setSearchParams]);

  const handleCohortChange = useCallback(
    (cohortIds: string[]) => {
      setSearchParams(
        cohortIds.length > 0 ? { cohort: cohortIds.join(',') } : {},
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return (
    <div className={classes.page}>
      <DataLibraryLayout
        defaultCohortId={cohortParam}
        defaultTab={initialView.tab}
        historyParticipantId={initialView.participant}
        onCohortChange={handleCohortChange}
      />
    </div>
  );
}
